webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__const__);




var Chessman = function () {
    function Chessman() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Chessman);

        this.state = __WEBPACK_IMPORTED_MODULE_2__const__["CHESSMAN_STATE"].DEFAULT;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Chessman, [{
        key: 'setState',
        value: function setState(state) {
            if (state && this.state === __WEBPACK_IMPORTED_MODULE_2__const__["CHESSMAN_STATE"].DEFAULT) {
                this.state = state;
            }
        }
    }, {
        key: 'isLocked',
        value: function isLocked() {
            return this.state !== __WEBPACK_IMPORTED_MODULE_2__const__["CHESSMAN_STATE"].DEFAULT;
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            return this.state === __WEBPACK_IMPORTED_MODULE_2__const__["CHESSMAN_STATE"].DEFAULT;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.state = __WEBPACK_IMPORTED_MODULE_2__const__["CHESSMAN_STATE"].DEFAULT;
        }
    }]);

    return Chessman;
}();

/* harmony default export */ __webpack_exports__["a"] = (Chessman);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports.CHESSMAN_STATE = {
    DEFAULT: 0,
    BLACK: 1,
    WHITE: 2
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(31),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__five_Five__ = __webpack_require__(14);



var five = new __WEBPACK_IMPORTED_MODULE_0__five_Five__["a" /* default */]();
window.five = five;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return { five: five };
    },

    methods: {
        isLast: function isLast(i, j) {
            var p = this.five.getLastChessmanPosition();
            return p && p.row === i && p.col === j;
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Chessman__ = __webpack_require__(4);




var Board = function () {
    function Board(width, height) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Board);

        this.width = width || 10;
        this.height = height || 10;
        this._board = [];
        this.init();
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Board, [{
        key: 'getBoard',
        value: function getBoard() {
            return this._board;
        }
    }, {
        key: 'getChessman',
        value: function getChessman(row, col) {
            try {
                return this._board[row][col];
            } catch (e) {
                return undefined;
            }
        }
    }, {
        key: 'forEach',
        value: function forEach(callback) {
            var i, j;
            for (i = 0; i < this.height; i++) {
                for (j = 0; j < this.width; j++) {
                    callback(this._board[i][j], i, j);
                }
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.forEach(function (item) {
                item.reset();
            });
        }
    }, {
        key: 'init',
        value: function init() {
            var i, j;
            this._board.length = 0;
            for (i = 0; i < this.height; i++) {
                this._board[i] = [];
                for (j = 0; j < this.width; j++) {
                    this._board[i].push(new __WEBPACK_IMPORTED_MODULE_2__Chessman__["a" /* default */]());
                }
            }
        }
    }, {
        key: 'boardChecker',
        value: function boardChecker() {
            var _this = this;
            var positionCache = {};
            var DIRECTION = {
                0: 0,
                90: 1,
                135: 2,
                45: 3
            };
            var winnerType;

            function setPositionResultFalse(row, col, direction) {
                var k = row + '-' + col;
                if (!positionCache[k]) {
                    positionCache[k] = {};
                }
                positionCache[k][direction] = false;
            }
            function isPositionDirectionFalse(row, col, direction) {
                var k = row + '-' + col;
                if (!positionCache[k]) {
                    return false;
                }
                return positionCache[k][direction] === false;
            }
            function checkPosition(row, col) {
                var result = false;
                [DIRECTION[0], DIRECTION[90], DIRECTION[135], DIRECTION[45]].forEach(function (direction) {
                    if (checkDirection(row, col, direction)) {
                        result = true;
                    }
                });
                return result;
            }
            function checkDirection(row, col, direction) {
                function getNextSameType(next, type, direction) {
                    var i;
                    var result = [];
                    for (i = 0; i < 4; i++) {
                        if (i >= 4) {
                            return result;
                        }
                        var _i = i + 1;
                        var nextRow, nextCol;
                        switch (direction) {
                            case DIRECTION[0]:
                                nextRow = row;
                                nextCol = next ? col + _i : col - _i;
                                break;
                            case DIRECTION[90]:
                                nextRow = next ? row + _i : row - _i;
                                nextCol = col;
                                break;
                            case DIRECTION[135]:
                                nextRow = next ? row + _i : row - _i;
                                nextCol = next ? col + _i : col - _i;
                                break;
                            case DIRECTION[45]:
                                nextRow = next ? row + _i : row - _i;
                                nextCol = next ? col - _i : col + _i;
                                break;
                        }
                        var nextOne = _this.getChessman(nextRow, nextCol);
                        if (nextOne) {
                            if (nextOne.state !== type) {
                                return result;
                            } else {
                                result.push({ row: nextRow, col: nextCol });
                            }
                        }
                    }
                    return result;
                }

                var chessman = _this.getChessman(row, col);
                if (chessman.isEmpty()) return false;
                if (isPositionDirectionFalse(row, col, direction)) return false;
                var type = chessman.state;
                var nextArr = getNextSameType(true, type, direction);
                var prevArr = getNextSameType(false, type, direction);
                var result = nextArr.length + prevArr.length + 1;
                if (result >= 5) {
                    winnerType = type;
                    return true;
                } else {
                    nextArr.concat(prevArr).forEach(function (o) {
                        setPositionResultFalse(o.row, o.col, direction);
                    });
                    return false;
                }
            }

            function checkAllChessman() {
                var result = false;
                _this.forEach(function (item, row, col) {
                    if (checkPosition(row, col)) {
                        result = true;
                    }
                });
                return result;
            }

            if (checkAllChessman()) {
                return winnerType;
            } else {
                return 0;
            }
        }
    }]);

    return Board;
}();

/* harmony default export */ __webpack_exports__["a"] = (Board);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Chessman__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Board__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__const__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Player__ = __webpack_require__(15);







var Five = function () {
    function Five() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Five);

        this.init();
        this._onUpdateState = null;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Five, [{
        key: 'init',
        value: function init() {
            this.board = new __WEBPACK_IMPORTED_MODULE_3__Board__["a" /* default */]();
            this.player = [new __WEBPACK_IMPORTED_MODULE_5__Player__["a" /* default */]('me', __WEBPACK_IMPORTED_MODULE_4__const__["CHESSMAN_STATE"].BLACK), new __WEBPACK_IMPORTED_MODULE_5__Player__["a" /* default */]('Alpha Go', __WEBPACK_IMPORTED_MODULE_4__const__["CHESSMAN_STATE"].WHITE)];
            this.history = [];
            this.winner = null;
            this.currentStep = -1;
        }
    }, {
        key: 'getLastChessmanPosition',
        value: function getLastChessmanPosition() {
            return this.history[this.currentStep];
        }
    }, {
        key: 'getNextStepPlayer',
        value: function getNextStepPlayer() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentStep;

            var isOdd = Math.abs(index % 2) === 0;
            return isOdd ? this.player[1] : this.player[0];
        }
    }, {
        key: 'nextStepChoseHere',
        value: function nextStepChoseHere(row, col, _player) {
            var player = this.getNextStepPlayer();
            if (_player && player !== _player) return;
            if (player.isLocked()) return;
            var chessman = this.board.getChessman(row, col);
            if (chessman.isLocked()) return;
            this.history.length = this.currentStep + 1;
            this.currentStep++;
            this.history.push({
                row: row, col: col,

                player: player.name
            });
            this.renderBoard();
        }
    }, {
        key: 'historyGo',
        value: function historyGo(step) {
            var target = this.currentStep + step;
            if (target === -1 || this.history[target]) {
                this.currentStep = target;
                this.renderBoard();
            }
        }
    }, {
        key: 'onUpdateState',
        value: function onUpdateState(callback) {
            this._onUpdateState = callback;
        }
    }, {
        key: 'renderBoard',
        value: function renderBoard() {
            var _this = this;

            var forkedHistory = [].concat(this.history);
            forkedHistory.length = this.currentStep + 1;
            this.board.reset();
            forkedHistory.forEach(function (obj, index) {
                var chessman = _this.board.getChessman(obj.row, obj.col);
                var player = _this.getNextStepPlayer(index - 1);
                chessman.setState(player.type);
            });
            var winnerType = this.board.boardChecker();
            if (winnerType > 0) {
                var winner;
                this.player.forEach(function (player) {
                    if (player.type === winnerType) {
                        winner = player;
                    }
                    player.lock();
                });
                this.winner = winner;
            }
            this._onUpdateState && this._onUpdateState();
        }
    }]);

    return Five;
}();

/* harmony default export */ __webpack_exports__["a"] = (Five);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Player = function () {
    function Player(name, type) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Player);

        this.name = name;
        this.type = type;
        this.locked = false;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Player, [{
        key: "lock",
        value: function lock() {
            this.locked = true;
        }
    }, {
        key: "unlock",
        value: function unlock() {
            this.locked = false;
        }
    }, {
        key: "isLocked",
        value: function isLocked() {
            return this.locked;
        }
    }]);

    return Player;
}();

/* harmony default export */ __webpack_exports__["a"] = (Player);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    now: " + _vm._s(_vm.five.getNextStepPlayer().name) + " "), _c('br'), _vm._v(" winner:" + _vm._s(_vm.five.winner || '-------') + "\n    "), _c('div'), _vm._v(" "), _vm._l((_vm.five.board.getBoard()), function(row, i) {
    return _c('div', {
      staticClass: "chess-row"
    }, _vm._l((row), function(chessman, j) {
      return _c('div', [_c('div', {
        class: ( _obj = {
          chessman: true,
            last: _vm.isLast(i, j)
        }, _obj['state-' + chessman.state] = true, _obj ),
        on: {
          "click": function($event) {
            _vm.five.nextStepChoseHere(i, j)
          }
        }
      })])
      var _obj;
    }))
  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.five.historyGo(-2);
      }
    }
  }, [_vm._v("悔棋")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.five.historyGo(2);
      }
    }
  }, [_vm._v("撤销悔棋")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.five.init();
      }
    }
  }, [_vm._v("初始化")]), _vm._v(" "), _c('h4', [_vm._v("History")]), _vm._v(" "), _c('ul', {
    staticClass: "history"
  }, _vm._l((_vm.five.history), function(h, i) {
    return _c('li', {
      class: {
        current: i === _vm.five.currentStep
      }
    }, [_vm._v("\n            " + _vm._s(h) + "\n        ")])
  }))], 2)
},staticRenderFns: []}

/***/ })
],[16]);


// WEBPACK FOOTER //
// static/js/app.65eff8882ed9a15bb9bb.js